import React from 'react'
import Experiment from '@mc/experiments-react'
import { EXPERIMENT_FLAG_KEY } from '../constants'
import { useExperimentCriteria } from '../hooks/useExperimentCriteria'

interface Pen5108ForBusinessWrapperProps {
  control?: React.ReactNode
  variant1?: React.ReactNode
}

export const Pen5108ForBusinessWrapper = ({
  control,
  variant1,
}: Pen5108ForBusinessWrapperProps) => {
  const { experimentCriteria } = useExperimentCriteria()
  if (!experimentCriteria) return control

  return (
    <Experiment
      name={EXPERIMENT_FLAG_KEY}
      control={() => control}
      variant_1={() => variant1}
      track={false}
    />
  )
}
